import { render, staticRenderFns } from "./DonutChart96.vue?vue&type=template&id=dd0bb116&scoped=true"
import script from "./DonutChart96.vue?vue&type=script&lang=js"
export * from "./DonutChart96.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0bb116",
  null
  
)

export default component.exports